import version from './version';

export * from './GaasLibraryInfo';
export const libraryVersion = version;